import React, { useState } from 'react'
import ChallengeSpaceSubmitChallengeStepForm from './ChallengeSpaceSubmitChallengeStepForm'
import ChallengeSpaceSubmissionInfo from './ChallengeSpaceSubmissionInfo'
import ChallengeSpaceLogin from './ChallengeSpaceLogin'
import { scrollToId } from 'utils/helpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons'

interface ChallengeSpaceSubmitChallengeCardProps {
	organisation: any
	space: any
	subject: any
}

const ChallengeSpaceSubmitChallengeCard = (
	props: ChallengeSpaceSubmitChallengeCardProps
) => {
	const { space, organisation, subject } = props
	const [newUser, setNewUser] = useState<boolean>(false)
	return (
		<div className="bg-yellow-300 rounded-lg shadow">
			<h2 className="text-2xl mb-4 font-sans font-bold px-8 pt-8">
				Submit Challenge
			</h2>

			<p className="mb-4 px-8 pb-4 text-lg">
				Submitting a challenge is easy. Provide a short title, some context and
				company details. We will review your challenge and if needed contact you
				to discuss.
			</p>
			{newUser ? (
				<>
					<div className="px-6 font-semibold py-3 border-t border-b border-black border-opacity-10">
						<button
							type="button"
							className="button border bg-black bg-opacity-0 border-black border-opacity-25 text-black hover:bg-opacity-5"
							onClick={() => setNewUser(false)}
						>
							<FontAwesomeIcon icon={faChevronLeft} className="mr-2" />
							Back
						</button>
					</div>
					<ChallengeSpaceSubmitChallengeStepForm
						challengeSpace={space}
						organisation={organisation}
					/>
				</>
			) : (
				<>
					<ChallengeSpaceSubmissionInfo
						challengeSpace={space}
						subject={subject}
					/>
					<div
						className="flex items-stretch flex-wrap overflow-hidden"
						id="formTop"
					>
						<div className="w-full md:w-1/2 border-b md:border-b-0 border-r bg-white md:rounded-bl-lg border-gray-100 p-8">
							<ChallengeSpaceLogin spaceId={space.id} />
						</div>

						<div className="w-full md:w-1/2 flex flex-col items-start rounded-b-lg md:rounded-bl-none justify-start p-8 bg-white">
							<h3 className="text-xl text-gray-900 font-semibold mb-4">
								No account yet?
							</h3>
							<p className="mb-4">
								No problem! You can create an account directly while submitting
								your challenge.
							</p>
							<button
								className="bg-purple-900 hover:bg-purple-800 duration-300 transition-colors text-white my-2"
								onClick={() => {
									setNewUser(true)
									scrollToId('submitSection')
								}}
							>
								Register &amp; submit challenge
							</button>
						</div>
					</div>
				</>
			)}
		</div>
	)
}

export default ChallengeSpaceSubmitChallengeCard
